module.exports = __webpack_public_path__ + "img/9.c0b4ab31.jpg";